import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Logo Vendeur.site animé — caddie tech avec balises </> au centre.
 *
 * SVG inline pour permettre l'animation indépendante de chaque partie
 * (caddie, roues, code, gradient). Taille fluide, couleur via tokens.
 *
 * Usage :
 *   <app-brand-logo size="md"></app-brand-logo>
 *   <app-brand-logo size="xl" [animated]="true"></app-brand-logo>
 */
@Component({
  selector: 'app-brand-logo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './brand-logo.component.html',
  styleUrls: ['./brand-logo.component.css'],
})
export class BrandLogoComponent {
  @Input() size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' = 'md';
  @Input() animated: boolean = false;
  @Input() showWordmark: boolean = false;
  @Input() variant: 'auto' | 'brand' | 'mono' | 'white' = 'auto';

  pxSize(): number {
    switch (this.size) {
      case 'xs':  return 20;
      case 'sm':  return 28;
      case 'md':  return 40;
      case 'lg':  return 64;
      case 'xl':  return 96;
      case '2xl': return 160;
      default:    return 40;
    }
  }
}
